<template>
  <div class="bg">
    <HeadView v-if="$store.getters.isPC"></HeadView>
    <template v-else>
      <MobileHeadView></MobileHeadView>
    </template>
    <div class="home clearFix width" v-if="$store.getters.isPC">
      <div class="floatL menu">
        <div class="center-title">个人中心</div>
        <ul>
          <li :class="activePath == item.path ? 'active' : ''" v-for="(item, index) in menuList" :key="index">
            <router-link :to="item.path">{{item.name}}</router-link>
          </li>
        </ul>
      </div>
      <el-container class="floatL">
        <router-view></router-view>
      </el-container>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
    <FooterView v-if="$store.getters.isPC"></FooterView>
    <template v-else>
    <MobileFooterView v-if="!isYiban"></MobileFooterView>
    </template>
  </div>
</template>

<script>
import HeadView from '@/components/Head'
import MobileHeadView from '@/components/MobileHead'
import FooterView from '@/components/Footer'
import MobileFooterView from '@/components/MobileFooter'
export default {
  data () {
    return {
      activePath: '',
      menuList: [
        {
          name: '首页',
          path: '/center'
        },
        {
          name: '个人资料',
          path: '/info'
        },
        {
          name: '我的订单',
          path: '/order-list'
        },
        {
          name: '我的收藏',
          path: '/my-favorite'
        },
        {
          name: '管理收货地址簿',
          path: '/address'
        },
        {
          name: '我的优惠券',
          path: '/coupon-list'
        },
        {
          name: '修改密码',
          path: '/modify-password'
        }
      ],
      isYiban: false
    }
  },
  components: {
    HeadView,
    MobileHeadView,
    FooterView,
    MobileFooterView
  },
  watch: {
    '$route.path' (val) {
      this.activePath = val
    }
  },
  created () {
    this.menuList.map(one => {
      if (one.path == this.$route.path) {
        this.activePath = one.path
      }
    })
    try {
      if (localStorage.getItem('isForm') == 1) {
        this.isYiban = true
      }
    } catch (error) {}
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/css/mixin';
  .bg {
    background: #F5F5F5;
  }
  .home {
    padding: 20px 0;
    .menu {
      width: 16vw;
      background: #fff;
      .center-title {
        // height: 48px;
        // line-height: 48px;
        padding: 20px;
        font-size: 20px;
        color: #757575;
        // background: $blue;
      }
      ul {
        line-height: 48px;
        font-size: 16px;
        li {
          padding-left: 20px;
          cursor: pointer;
        }
        li:hover {
          background: #edf1f8;
        }
        li.active {
          background: #edf1f8;
        }
      }
    }
    .el-container {
      width: calc(100% - 16vw - 20px);
      margin-left: 20px
    }
  }
  @media only screen and (min-width: 1441px) {
    .home {
      .menu {
        width: 15vw;
        ul {
          line-height: 55px;
        }
      }
      .el-container {
        width: calc(100% - 15vw - 20px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/Home.vue